import { render, staticRenderFns } from "./SideRight.vue?vue&type=template&id=202bf744&scoped=true"
import script from "./SideRight.vue?vue&type=script&lang=js"
export * from "./SideRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202bf744",
  null
  
)

export default component.exports